import React from 'react'
import {BsClipboardData} from "react-icons/bs";

const homeConfig = {

    greeting:
        <h1 className="heading">
            Hi! I'm <strong className="main-name"> Om Sanjay Sangwan</strong>
        </h1>,
    titles: [
        "Data & BI Engineer",
        "Machine Learning Specialist",
        "Certified in Databricks, Azure & Fabric"
    ],
    about: {
        start: "I am a Data & BI Engineer with a strong foundation in analytics and machine learning. " +
            "With over 3 years of experience, I specialize in building robust data pipelines, interactive dashboards, and AI-powered solutions. " +
            "I'm certified by Databricks, Azure, and Microsoft Fabric, demonstrating expertise in modern data platforms.",
        exit: "I am proficient in Python, SQL, and BI tools like Power BI and Qlik Sense, " +
            "with extensive experience in cloud platforms such as Azure, Databricks, and Snowflake. " +
            "I stay at the forefront of AI advancements and have a keen interest in applying technology to solve complex data challenges."
    },
    workTimeline: [
        {
            id: "work-9",
            title: "Business Intelligence Engineer",
            company: "Fiddlehead Technology",
            description: "Led development for an AI-powered freight security product and engineered data pipelines integrating Snowflake and MongoDB with web APIs.",
            date: "2025-Present",
            icon: <BsClipboardData/>,
            tags: ["snowflake", "mongodb", "powerbi", "web-apis", "pipelines"]
        },
        {
            id: "work-8",
            title: "Business Intelligence Consultant",
            company: "JCA",
            description: "Designed and implemented interactive dashboards using Power BI and Vega, and optimized existing reports through DAX refactoring.",
            date: "2025",
            icon: <BsClipboardData/>,
            tags: ["powerbi", "vega", "dax", "analytics"]
        },
        {
            id: "work-7",
            title: "AI Engineer",
            company: "DataSphere Lab @ McGill University",
            description: "Implemented an end-to-end AI framework for artwork analysis using OpenAI, Pydantic, and Azure.",
            date: "2024",
            icon: <BsClipboardData/>,
            tags: ["python", "openai", "azure", "pydantic", "cv"]
        },
        {
            id: "work-4",
            title: "Data Analytics & AI Solutions Intern",
            company: "Ontario Teachers' Pension Plan",
            description: "Engineered 10+ Power BI dashboards integrating Snowflake and built automated data refresh pipelines using Power Automate.",
            date: "2024",
            icon: <BsClipboardData/>,
            tags: ["powerbi", "snowflake", "power-automate", "sql"]
        },
        {
            id: "work-5",
            title: "Research Assistant",
            company: "UMass Boston",
            description: "Conducted sentiment analysis using OpenAI tools and Google's Perspective API to support research on public opinion trends on abortion perspectives.",
            date: "2024",
            icon: <BsClipboardData/>,
            tags: ["openai", "sentiment-analysis", "google-perspective-api", "research"]
        },
        {
            id: "work-3",
            title: "Data Engineer & BI Consultant",
            company: "L'Oréal",
            description: "Assisted in creating ETL pipelines in Databricks and delivered custom Power BI reports for marketing and customer retention.",
            date: "2023-2024",
            icon: <BsClipboardData/>,
            tags: ["databricks", "powerbi", "etl", "python", "sql"]
        },
        {
            id: "work-2",
            title: "BI Engineer",
            company: "Impendi",
            description: "Led development of Qlik Sense dashboards, automated ETL processes, and delivered high-impact Spend Analytics projects.",
            date: "2021-2023",
            icon: <BsClipboardData/>,
            tags: ["qliksense", "python", "smartsheet", "excel", "sql", "alteryx"]
        },
        {
            id: "work-1",
            title: "Data Analyst Intern",
            company: "Goldilocks",
            description: "Automated Options data analysis, improving investment decision-making and boosting revenue by 7% via Python-based tools.",
            date: "2021",
            icon: <BsClipboardData/>,
            tags: ["python", "webscraping", "nsepy", "excel", "xlwings"]
         }
     ]
}

export default homeConfig
